import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';
import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.kiera.images');
import { OnInit } from '@angular/core';
import { Service } from 'src/libs/portal/season/service';

@Component({
 standalone: false,
 selector: 'wiz-page-kiera-images',
template: templateSource || '',
    styles: [``],
})
export class PageKieraImagesComponent implements OnInit {
    public list: any[] = [];
    public total: number = 0;
    public search: any = { text: "", type: "", page: 1, dump: 20 };

    // Sorting
    public sortField: string = 'id';
    public sortDir: string = 'asc';

    // Image Type 매핑 (DB integer 기준)
    public typeOptions = [
        { value: 1, label: 'Cloud Image' },
        { value: 2, label: 'Safe Backup' },
        { value: 3, label: 'Live Backup' },
        { value: 10, label: 'Disk-Less Linux' },
    ];

    // Scripts
    public scripts: any[] = [];

    // Diskless Linux Images (for linking)
    public disklessImages: any[] = [];

    // Add Image Modal
    public showAddModal: boolean = false;
    public newImage: any = { name: '', type: 1, arch: 'amd64', os: 'ubuntu', pre_script_id: '', post_script_id: '', disk_less_linux_id: '' };
    public archOptions: string[] = ['amd64', 'arm64'];
    public osOptions: string[] = ['ubuntu', 'centos', 'rocky'];
    public selectedRootfs: File | null = null;

    // Upload progress
    public uploading: boolean = false;
    public uploadProgress: number = 0;
    public uploadFileName: string = '';

    // Edit Modal
    public showEditModal: boolean = false;
    public editItem: any = null;

    // Diskless Link Modal
    public showDisklessModal: boolean = false;
    public disklessLinkItem: any = null;

    // Deployment stats & relations
    public deployStats: any[] = [];
    public deploySummary: any = {};
    public relayRelations: any[] = [];
    public deliverers: any[] = [];
    public showPipeline: boolean = true;
    public relationPage: number = 1;
    public relationPageSize: number = 5;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow("/access");
        await this.loadScripts();
        await this.loadDisklessImages();
        await this.load();
        await this.loadDeploymentStats();
        await this.loadImageRelations();
        await this.service.render();
    }

    public async load(page: number = 1) {
        this.search.page = page;
        const { code, data } = await wiz.call("search", this.search);
        if (code === 200) {
            this.list = data.rows;
            this.total = data.total;
            // Enrich pre/post script names
            for (const item of this.list) {
                item.pre_script_name = this.getScriptName(item.pre_script_id);
                item.post_script_name = this.getScriptName(item.post_script_id);
            }
            this.sortList();
        }
        await this.service.render();
    }

    public async loadScripts() {
        const { code, data } = await wiz.call("scripts");
        if (code === 200) this.scripts = data.rows || [];
    }

    public async loadDisklessImages() {
        const { code, data } = await wiz.call("diskless_images");
        if (code === 200) this.disklessImages = data.rows || [];
    }

    public async loadDeploymentStats() {
        const { code, data } = await wiz.call("deployment_stats");
        if (code === 200) {
            this.deployStats = data.stats || [];
            this.deploySummary = data.summary || {};
        }
    }

    public async loadImageRelations() {
        const { code, data } = await wiz.call("image_relations");
        if (code === 200) {
            this.relayRelations = data.relations || [];
            this.deliverers = data.deliverers || [];
            this.relationPage = 1;
        }
    }

    public async togglePipeline() {
        this.showPipeline = !this.showPipeline;
        await this.service.render();
    }

    public onFileSelected(event: any) {
        const files = event.target.files;
        if (files && files.length > 0) {
            this.selectedRootfs = files[0];
        }
        this.service.render();
    }

    private uploadFile(url: string, formData: FormData, fileName: string): Promise<void> {
        return new Promise((resolve, reject) => {
            this.uploadFileName = fileName;
            this.uploadProgress = 0;
            this.service.render();
            const xhr = new XMLHttpRequest();
            xhr.upload.addEventListener('progress', (e) => {
                if (e.lengthComputable) {
                    this.uploadProgress = Math.round((e.loaded / e.total) * 100);
                    this.service.render();
                }
            });
            xhr.addEventListener('load', () => {
                if (xhr.status >= 200 && xhr.status < 300) {
                    resolve();
                } else {
                    reject(new Error(`Upload failed (HTTP ${xhr.status})`));
                }
            });
            xhr.addEventListener('error', () => reject(new Error('Upload failed')));
            xhr.open('POST', url);
            const csrfCookie = document.cookie.split(';')
                .map((value: string) => value.trim())
                .find((value: string) => value.indexOf('KIERA_CSRF=') === 0);
            if (csrfCookie) xhr.setRequestHeader('X-KiERA-CSRF', csrfCookie.substring('KIERA_CSRF='.length));
            xhr.withCredentials = true;
            xhr.send(formData);
        });
    }

    public async addImage() {
        if (!this.newImage.name) return;
        this.uploading = true;
        this.uploadProgress = 0;
        this.uploadFileName = '';
        await this.service.render();

        try {
            const { code, data } = await wiz.call("create", { data: JSON.stringify(this.newImage) });
            if (code !== 200) {
                alert(data?.message || 'Failed to create image');
                this.uploading = false;
                await this.service.render();
                return;
            }
            const imageId = data.id;

            if (this.selectedRootfs && imageId) {
                const formData = new FormData();
                formData.append('rootfs_file', this.selectedRootfs);
                await this.uploadFile(`/wiz/api/page.kiera.images/upload_rootfs?id=${imageId}`, formData, this.selectedRootfs.name);
            }

            this.showAddModal = false;
            this.newImage = { name: '', type: 1, arch: 'amd64', os: 'ubuntu', pre_script_id: '', post_script_id: '', disk_less_linux_id: '' };
            this.selectedRootfs = null;
            await this.load();
            await this.loadDeploymentStats();
        } catch (e: any) {
            alert(e?.message || 'An error occurred');
        } finally {
            this.uploading = false;
            this.uploadProgress = 0;
            this.uploadFileName = '';
            await this.service.render();
        }
    }

    public openAddModal() {
        this.showAddModal = true;
        this.selectedRootfs = null;
        this.newImage = { name: '', type: 1, arch: 'amd64', os: 'ubuntu', pre_script_id: '', post_script_id: '', disk_less_linux_id: '' };
        this.service.render();
    }

    public editImage(item: any) {
        this.editItem = {
            ...item,
            pre_script_id: item.pre_script_id || '',
            post_script_id: item.post_script_id || '',
            disk_less_linux_id: item.disk_less_linux_id || ''
        };
        this.showEditModal = true;
        this.service.render();
    }

    public async saveEdit() {
        if (!this.editItem) return;
        const payload = { ...this.editItem };
        if (payload.pre_script_id === '') payload.pre_script_id = null;
        if (payload.post_script_id === '') payload.post_script_id = null;
        if (payload.disk_less_linux_id === '') payload.disk_less_linux_id = null;
        const { code } = await wiz.call("update", { id: this.editItem.id, data: JSON.stringify(payload) });
        if (code === 200) {
            this.showEditModal = false;
            this.editItem = null;
            await this.load();
        }
    }

    public downloadImage(id: number) {
        window.open(`/wiz/api/page.kiera.images/download?id=${id}`, '_blank');
    }

    public formatSize(bytes: any): string {
        if (!bytes || bytes === 0) return '';
        const b = Number(bytes);
        const units = ['B', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(b) / Math.log(1024));
        return (b / Math.pow(1024, i)).toFixed(1) + ' ' + units[i];
    }

    public async deleteImage(id: number) {
        if (!confirm("Are you sure you want to delete this image?")) return;
        const { code } = await wiz.call("delete", { id });
        if (code === 200) {
            await this.load();
            await this.loadDeploymentStats();
        }
    }

    public async hashRecreate(id: number) {
        const { code, data } = await wiz.call("hash_recreate", { id });
        if (code === 200) {
            alert(`MD5 hash recreated: ${data.md5}`);
            await this.load();
        } else {
            alert(data?.message || 'Hash recreate failed');
        }
    }

    public async filterType(type: any) {
        if (type === '') {
            this.search.type = "";
        } else {
            this.search.type = this.search.type === type ? "" : type;
        }
        await this.load();
    }

    // ===== Sorting =====
    public async sort(field: string) {
        if (this.sortField === field) {
            this.sortDir = this.sortDir === 'asc' ? 'desc' : 'asc';
        } else {
            this.sortField = field;
            this.sortDir = 'asc';
        }
        this.sortList();
        await this.service.render();
    }

    private sortList() {
        const field = this.sortField;
        const dir = this.sortDir === 'asc' ? 1 : -1;
        this.list.sort((a: any, b: any) => {
            let va = a[field];
            let vb = b[field];
            if (va == null) va = '';
            if (vb == null) vb = '';
            if (field === 'id' || field === 'type') {
                return (Number(va) - Number(vb)) * dir;
            }
            return String(va).localeCompare(String(vb)) * dir;
        });
    }

    public getSortIcon(field: string): string {
        if (this.sortField !== field) return 'bx-sort-alt-2';
        return this.sortDir === 'asc' ? 'bx-sort-up' : 'bx-sort-down';
    }

    // ===== Inline script change =====
    public async onScriptChange(item: any, field: string) {
        const payload: any = {};
        payload[field] = item[field] === '' ? null : item[field];
        const { code } = await wiz.call("update", { id: item.id, data: JSON.stringify(payload) });
        if (code === 200) {
            if (field === 'pre_script_id') item.pre_script_name = this.getScriptName(item.pre_script_id);
            if (field === 'post_script_id') item.post_script_name = this.getScriptName(item.post_script_id);
        }
        await this.service.render();
    }

    public getTypeName(type: any): string {
        const val = Number(type);
        const opt = this.typeOptions.find(t => t.value === val);
        return opt ? opt.label : 'None';
    }

    public getTypeBadgeClass(type: any): string {
        const val = Number(type);
        switch (val) {
            case 1: return 'bg-blue-100 text-blue-700';
            case 2: return 'bg-green-100 text-green-700';
            case 3: return 'bg-amber-100 text-amber-700';
            case 10: return 'bg-purple-100 text-purple-700';
            default: return 'bg-zinc-100 text-zinc-600';
        }
    }

    public getScriptName(id: any): string {
        if (!id) return '-';
        const s = this.scripts.find((s: any) => s.id === Number(id));
        return s ? s.name : '-';
    }

    public getDisklessName(id: any): string {
        if (!id) return '-';
        const d = this.disklessImages.find((d: any) => d.id === Number(id));
        return d ? `${d.name} (${d.os}/${d.arch})` : '-';
    }

    // Diskless linking modal
    public openDisklessLink(item: any) {
        this.disklessLinkItem = { ...item, disk_less_linux_id: item.disk_less_linux_id || '' };
        this.showDisklessModal = true;
        this.service.render();
    }

    public async saveDisklessLink() {
        if (!this.disklessLinkItem) return;
        const dlId = this.disklessLinkItem.disk_less_linux_id;
        const { code } = await wiz.call("update", {
            id: this.disklessLinkItem.id,
            data: JSON.stringify({ disk_less_linux_id: dlId === '' ? null : dlId })
        });
        if (code === 200) {
            this.showDisklessModal = false;
            this.disklessLinkItem = null;
            await this.load();
        }
        await this.service.render();
    }

    public totalPages() {
        return Math.ceil(this.total / this.search.dump) || 1;
    }

    public pageRange() {
        const tp = this.totalPages();
        const current = this.search.page;
        return this.buildPageRange(current, tp);
    }

    public getPagedRelayRelations(): any[] {
        const start = (this.relationPage - 1) * this.relationPageSize;
        return this.relayRelations.slice(start, start + this.relationPageSize);
    }

    public relationTotalPages(): number {
        return Math.max(1, Math.ceil(this.relayRelations.length / this.relationPageSize));
    }

    public relationPageRange(): number[] {
        return this.buildPageRange(this.relationPage, this.relationTotalPages());
    }

    public async setRelationPage(page: number) {
        this.relationPage = page;
        await this.service.render();
    }

    private buildPageRange(current: number, total: number): number[] {
        const delta = 2;
        let start = Math.max(1, current - delta);
        let end = Math.min(total, current + delta);
        if (end - start < delta * 2) {
            if (start === 1) end = Math.min(total, start + delta * 2);
            else start = Math.max(1, end - delta * 2);
        }
        const pages = [];
        for (let i = start; i <= end; i++) pages.push(i);
        return pages;
    }

    // ===== Deploy stat helpers =====
    public getDeployBarWidth(stat: any, field: string): string {
        if (!stat.total_nodes || stat.total_nodes === 0) return '0%';
        return Math.round((stat[field] / stat.total_nodes) * 100) + '%';
    }
}

export default PageKieraImagesComponent;
